import axios from '@/plugins/axios';

export async function exportDebtRequestStatisticExportResponseLatency(){
    return await axios.get(`admin/export-debt-request-statistic/export-response-latency`);
}